/**
 * General Clinical Assessment Data Points
 * Category: General
 */

export const generalDataPoints = [
  // Main Complaint
  {
    id: 'main_complaint',
    label: 'MAIN COMPLAINT',
    category: 'General',
    subcategory: 'History Taking',
    fieldType: 'multi',
    isActive: true,
    options: ['Fever', 'Pain', 'Trauma', 'Fall'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Select all presenting complaints that apply'
    },
    code: '422979000', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Present For
  {
    id: 'present_for',
    label: 'Present for',
    category: 'General',
    subcategory: 'History Taking',
    fieldType: 'multi',
    isActive: true,
    options: ['Years', 'Months', 'Weeks', 'Days', 'Hours'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Select the duration of symptoms'
    },
    code: '282032007', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Brought In By
  {
    id: 'brought_in_by',
    label: 'Brought in by',
    category: 'General',
    subcategory: 'History Taking',
    fieldType: 'multi',
    isActive: true,
    options: ['Ambulance', 'Police', 'Family', 'Self', 'Friends', 'Unknown'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'How did the patient arrive at the facility'
    },
    code: '184140000', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // General Symptoms
  {
    id: 'general_symptoms',
    label: 'General',
    category: 'General',
    subcategory: 'Symptoms Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Malaise', 'Fever', 'Chills', 'Weakness'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Select all general symptoms present'
    },
    code: '418799008', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Quick Exams - CVS
  {
    id: 'cvs_quick',
    label: 'CVS',
    category: 'General',
    subcategory: 'Quick Exams',
    fieldType: 'multi',
    isActive: true,
    options: ['Chest pain', 'Dyspnoea', 'PND', 'Oedema palpitations'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Cardiovascular system quick screening'
    },
    code: '113091000', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Quick Exams - GIT
  {
    id: 'git_quick',
    label: 'GIT',
    category: 'General',
    subcategory: 'Quick Exams',
    fieldType: 'multi',
    isActive: true,
    options: [
      'Nausea',
      'Vomiting',
      'Heartburn',
      'Weight loss',
      'Jaundice',
      'Abdominal pain',
      'Blood PR',
      'Diarrhoea',
      'Constipation',
      'Faecal incontinence'
    ],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Gastrointestinal system quick screening'
    },
    code: '86762007', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Quick Exams - Uro/Gyn General
  {
    id: 'urogyn_quick',
    label: 'Uro/Gyn',
    category: 'General',
    subcategory: 'Quick Exams',
    fieldType: 'multi',
    isActive: true,
    options: ['Haematuria', 'Burning', 'Scalding frequency', 'Hesitancy', 'Incontinence'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Urogenital system quick screening - general symptoms'
    },
    code: '21514008', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Quick Exams - Uro/Gyn Male
  {
    id: 'urogyn_male_quick',
    label: 'Uro/Gyn - Male',
    category: 'General',
    subcategory: 'Quick Exams',
    fieldType: 'multi',
    isActive: true,
    options: ['Discharge', 'Testicular pain/swelling'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Male-specific urogenital symptoms'
    },
    code: '248536006', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Quick Exams - Uro/Gyn Female
  {
    id: 'urogyn_female_quick',
    label: 'Uro/Gyn - Female',
    category: 'General',
    subcategory: 'Quick Exams',
    fieldType: 'multi',
    isActive: true,
    options: ['Vaginal discharge', 'Abn bleeding'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Female-specific urogenital symptoms'
    },
    code: '248549009', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Quick Exams - CNS
  {
    id: 'cns_quick',
    label: 'CNS',
    category: 'General',
    subcategory: 'Quick Exams',
    fieldType: 'multi',
    isActive: true,
    options: ['Headaches', 'Blackouts', 'Dizziness', 'Weakness'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Central nervous system quick screening'
    },
    code: '25087005', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Quick Exams - Endocrine
  {
    id: 'endocrine_quick',
    label: 'Endocrine',
    category: 'General',
    subcategory: 'Quick Exams',
    fieldType: 'multi',
    isActive: true,
    options: ['Weight gain', 'Weight loss', 'Intolerance to heat/cold', 'Excessive thirst'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Endocrine system quick screening'
    },
    code: '113331007', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Quick Exams - Locomotor
  {
    id: 'locomotor_quick',
    label: 'Locomotor',
    category: 'General',
    subcategory: 'Quick Exams',
    fieldType: 'multi',
    isActive: true,
    options: ['Pain/swelling in joints'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Musculoskeletal system quick screening'
    },
    code: '113192009', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Quick Exams - Skin
  {
    id: 'skin_quick',
    label: 'Skin',
    category: 'General',
    subcategory: 'Quick Exams',
    fieldType: 'multi',
    isActive: true,
    options: ['Rash', 'Itching', 'Bruising'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Integumentary system quick screening'
    },
    code: '39937001', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // History - Allergies
  {
    id: 'allergies',
    label: 'Allergies',
    category: 'General',
    subcategory: 'History',
    fieldType: 'multi',
    isActive: true,
    options: ['Penicillin', 'Nuts', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other allergies...',
      helpText: 'Select known allergies or specify others'
    },
    code: '418038007', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // History - PMH (Patient Medical History)
  {
    id: 'pmh',
    label: 'PMH',
    category: 'General',
    subcategory: 'History',
    fieldType: 'multi',
    isActive: true,
    options: ['DM Type I', 'Type II', 'Asthma', 'Epilepsy', 'HPT', 'HyperCholesterol', 'COPD', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other medical conditions...',
      helpText: 'Select past medical history or specify others'
    },
    code: '392521001', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // History - PSH (Patient Surgical History)
  {
    id: 'psh',
    label: 'PSH',
    category: 'General',
    subcategory: 'History',
    fieldType: 'multi',
    isActive: true,
    options: ['Appendicectomy', 'Hysterectomy', 'Back surgery', 'Sinus surgery', 'Orthopaedic surgery', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other surgical procedures...',
      helpText: 'Select past surgical history or specify others'
    },
    code: '387713003', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // History - Medications
  {
    id: 'medications',
    label: 'Medications',
    category: 'General',
    subcategory: 'History',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'text',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'List current medications...',
      helpText: 'Enter current medications, dosages, and frequency'
    },
    code: '182836005', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // On Examination - Appearance
  {
    id: 'appearance',
    label: 'Appearance',
    category: 'General',
    subcategory: 'On Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Comfortable', 'Distressed', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other appearance...',
      helpText: 'Select patient appearance during examination'
    },
    code: '386053000', // SNOMED CT - Patient appearance
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // On Examination - Hydration Status
  {
    id: 'hydration_status',
    label: 'Hydration status',
    category: 'General',
    subcategory: 'On Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Mild dehydration', 'Significant dehydration'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Assess patient hydration status'
    },
    code: '34095006', // SNOMED CT - Dehydration
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // On Examination - Jaundice
  {
    id: 'jaundice',
    label: 'Jaundice',
    category: 'General',
    subcategory: 'On Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Present', 'Absent'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Check for presence of jaundice'
    },
    code: '18165001', // SNOMED CT - Jaundice
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // On Examination - Anaemia
  {
    id: 'anaemia',
    label: 'Anaemia',
    category: 'General',
    subcategory: 'On Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Present', 'Absent'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Check for clinical signs of anaemia'
    },
    code: '271737000', // SNOMED CT - Anaemia
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // On Examination - Clubbing
  {
    id: 'clubbing',
    label: 'Clubbing',
    category: 'General',
    subcategory: 'On Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Present', 'Absent'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Check for digital clubbing'
    },
    code: '12770006', // SNOMED CT - Clubbing
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // On Examination - Cyanosis
  {
    id: 'cyanosis',
    label: 'Cyanosis',
    category: 'General',
    subcategory: 'On Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Present', 'Absent'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Check for presence of cyanosis'
    },
    code: '3415004', // SNOMED CT - Cyanosis
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // On Examination - Rash
  {
    id: 'rash',
    label: 'Rash',
    category: 'General',
    subcategory: 'On Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Yes', 'No'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Check for presence of skin rash'
    },
    code: '271807003', // SNOMED CT - Rash
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // On Examination - Lymphadenopathy
  {
    id: 'lymphadenopathy',
    label: 'Lymphadenopathy',
    category: 'General',
    subcategory: 'On Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Yes', 'No'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Check for enlarged lymph nodes'
    },
    code: '30746006', // SNOMED CT - Lymphadenopathy
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
]

export default generalDataPoints
